<div class="wm-workspace">
    <div class="wm-api-designer clearfix" tabindex="1">
        <div class="full-height" *ngIf="!apiService.noServicesFound">
                    <!-- Workspace header -->
        <div class="workspace-header" *ngIf="!apiService.ctrlOptions.readOnlyMode">

<!--            <div class="wm-actions-center" *wmsFeature="!project.apidesigner.edit">-->
<!--                <span title="{{locale.LABEL_SCHEMA_READONLY_MODE}}" class="readonly-schema">-->
<!--                    <span>{{locale.LABEL_SCHEMA_READONLY_MODE}}</span>-->
<!--                </span>-->
<!--            </div>-->
            <div class="wm-actions-right">
                <ul class="btn-group view-toolbar">
                        <!-- Re-import Button -->
                        <!-- <li [ngClass]="{'guided-tour': apiWsService.showGuidedTour}" *ngIf="apiService.activeServiceType === 'OpenAPIService'">
                                <button class="button-primary btn app-button"
                                        *ngIf="!(preferences.project.actions.inspect && preferences.project.actions.inspect.disable) && preferences.project.openapi.edit"
                                        title="{{locale.LABEL_RE_IMPORT_APIS}}"
                                        (click)="apiWsService.openReimportAPIDialog()">{{locale.LABEL_RE_IMPORT_APIS}}</button>
                                <div *ngIf="apiWsService.showGuidedTour" class="info-ctnr">
                                  <i></i>
                                  <label>{{locale.HEADING_RE_IMPORT_API_TOUR}}</label>
                                  <p>{{locale.MESSAGE_RE_IMPORT_API_TOUR}}</p>
                                  <button class="float-right" (click)="apiWsService.hideGuidedTour()">{{locale.LABEL_DONE}}</button>
                                </div>
                        </li> -->
                    <!-- Refresh button -->
                    <!-- <li>
                        <button class="wm-icon24 wms wms-refresh wm-workspace-action"
                            title="{{locale.ICONTITLE_WORKSPACE_REFRESH}}" (click)="apiWsService.refreshApi()"></button>
                    </li> -->
                    <!-- Save button (disabled for security service) -->
                    <!-- <li *wmsFeature="project.apidesigner.edit">
                        <button class="wm-icon24 wms wms-save wm-workspace-action"
                            [disabled]="apiService.activeApiHead?.api.name === 'security-services'"
                            title="{{locale.ICONTITLE_WORKSPACE_SAVE}}" (click)="apiWsService.updateApi()"></button>
                    </li> -->
                        <!-- Delete button-->
                        <!-- <li *ngIf="apiService.activeServiceType === 'OpenAPIService'">
                            <button *wmsFeature="preferences.project.openapi.delete" class="wm-icon24 wms wms-delete wm-workspace-action"
                                title="{{locale.ICONTITLE_WORKSPACE_DELETE}}"
                                (click)="apiWsService.deleteSelectedService($event)"></button>
                    </li> -->
                </ul>
            </div>
        </div>

        <div class="workspace-content"
            [ngClass]="{'api-viewer': apiService.selectedTab === 'SETTINGS'}">
                <div class="full-height" [hidden]="apiService.selectedTab !== 'ENDPOINTS'">
                            <!-- api list -->
        <div class="api-list" *ngIf="apiService.services?.length > 0">
            <div class="fixed-header hide-search">
                <h3 class="end-points">{{locale.LABEL_ENDPOINTS}}</h3>
                <wms-search  *ngIf="!hideActions" (onSearch)="apiService.endPointFilter($event.searchKey)" [disabled]="disableSearch"></wms-search>
            </div>
            <div class="list">
                <div
                    *ngIf="apiService.activeServiceType !== apiService.serviceTypeConstants.DATA_SERVICE && apiService.activeServiceType !== 'OpenAPIService'">
                    <ul class="end-points-list">
                        <li routerLink="/apis/{{apiService.activeApiHead.api.name}}/{{getInnerHtml(service.apis && service.apis[0])}}" *ngFor="let service of apiService.filteredServices" [ngClass]="{'active': service.apis && service.apis[0].isActive}"
                            (click)="setActiveApi($event, service.apis && service.apis[0], true, undefined, true)"
                            [innerHTML]="getInnerHtml(service.apis && service.apis[0])"></li>
                    </ul>
                </div>
                <div
                    *ngIf="apiService.activeServiceType !== apiService.serviceTypeConstants.DATA_SERVICE && apiService.activeServiceType === 'OpenAPIService'">
                    <ul class="end-points-list">
                        <li  routerLink="/apis/{{apiService.currentService.name}}/{{api.controllerName}}"  *ngFor="let api of apiService.currentService?.filteredApis" [ngClass]="{'active': api.isActive}"
                            (click)="setActiveApi($event, api, true)" [innerHTML]="getInnerHtml(api)">
                        </li>
                    </ul>
                </div>
                <div *ngIf="apiService.activeServiceType === apiService.serviceTypeConstants.DATA_SERVICE">
                    <ul class="services-list">
                        <div class="expand-toggle" (click)="apiService.currentService.open = !apiService.currentService.open">
                            <i class="icon8"
                                [ngClass]="{'expanded': apiService.currentService?.open, 'collapsed': !apiService.currentService?.open}"
                                [attr.title]="getDStitle()"></i>
                            <label style="padding-left: 3px;">{{locale.LABEL_ENTITIES}}</label>
                        </div>
                        <ul class="end-points-list" *ngIf="apiService.currentService?.open">
                            <ng-container *ngFor="let api of apiService.currentService?.filteredApis">
                                <li *ngIf="api.controllerName !== 'QueryExecutionController' && api.controllerName !== 'ProcedureExecutionController'"
                                    routerLink="/apis/{{apiService.currentService?.name}}/{{api['x-WM-RELATIVE_PATH']}}"
                                    [ngClass]="{active: api.isActive}" (click)="setActiveApi($event, api, true)"
                                    [innerHTML]="getInnerHtml(api)"
                                    [title]="getInnerHtml(api)"></li>
                            </ng-container>
                        </ul>
                        <div class="expand-toggle">
                            <label>{{locale.LABEL_QUERIES}}</label>
                        </div>
                        <ul class="end-points-list">
                            <li *ngIf="apiService.currentService?.queryTag" [ngClass]="{active: apiService.currentService.queryTag.isActive}"
                                (click)="setActiveApi($event, apiService.currentService?.queryTag, true)"
                                routerLink="/apis/{{apiService.currentService?.name}}/{{getInnerHtml(apiService.currentService?.queryTag)}}"
                                [innerHTML]="getInnerHtml(apiService.currentService?.queryTag)"
                                [title]="getInnerHtml(apiService.currentService?.queryTag)"></li>
                        </ul>
                        <div class="expand-toggle">
                            <label>{{locale.LABEL_PROCEDURES}}</label>
                        </div>
                        <ul class="end-points-list">
                            <li *ngIf="apiService.currentService?.procedureTag"
                                routerLink="/apis/{{apiService.currentService?.name}}/{{getInnerHtml(apiService.currentService?.procedureTag)}}"
                                [ngClass]="{active: apiService.currentService?.procedureTag.isActive}"
                                (click)="setActiveApi($event, apiService.currentService?.procedureTag, true)"
                                [innerHTML]="getInnerHtml(apiService.currentService?.procedureTag)"
                                [title]="getInnerHtml(apiService.currentService?.procedureTag)"></li>
                        </ul>
                    </ul>
                </div>
            </div>
        </div>

        <!-- selected api viewer -->
        <div class="api-viewer" wm-infinite-scroll *ngIf="apiService.services?.length > 0 && !apiService.hideActions"
            [ngClass]="{'hide-swagger': apiService.filteredPaths_length === 0}">
            <div class="fixed-header">
                <!-- API URL -->
                <div class="col-md-6 header-text">
                    <label [ngClass]="{'openapi-heading': apiService.activeServiceType === 'OpenAPIService'}" [attr.title]="getBasePathKey(apiService.activeApi)" *ngIf="apiService?.filteredPaths_length">{{getBasePathKey(apiService.activeApi)}}</label>
                </div>
                <!-- Filter -->
                <div class="panel-group search-container col-md-6" *ngIf="!hideActions">
                    <i title="Filter Endpoints" class="wm-icon12 wms wms-widget-livefilter filter-icon"></i>
                    <select [(ngModel)]="apiService.searchKeys.methodType" class="api-select">
                        <option *ngFor="let option of apiService.allMethods" [value]="option">{{option}}</option>
                    </select>
                    <wms-search (onSearch)="apiService.endPointFilter($event.searchKey)" [disabled]="disableSearch"></wms-search>
                </div>
            </div>

            <div class="listContainer resource" >
                <!-- API Description -->
			    <div *ngIf="!apiService.ctrlOptions.readOnlyMode && apiService?.filteredPaths_length">
                    <label class="col-md-3 description">{{locale.LABEL_DESCRIPTION}}</label>
                    <!-- (change)="markDirty()" - TO DO -->
                    <textarea *ngIf="apiService.activeApiHead?.api.name !== 'security-services'" class="col-md-9 api-textarea api-desc" placeholder="api description" [ngModel]="apiService.activeApi && apiService.activeApi.description" (ngModelChange)="apiService.activeApi && (apiService.activeApi.description = $event)" (ngModelOptions)="{updateOn: 'blur, change'}" disabled></textarea>
                    <label *ngIf="apiService.activeApiHead?.api.name === 'security-services'" class="col-md-9 api-desc">{{apiService.activeApi?.description || locale.LABEL_NO_DESC_FOUND}}</label>

                </div>
                <router-outlet></router-outlet>
                <span class="no-methods" *ngIf="apiService.filteredPaths_length === 0">{{locale.MESSAGE_NO_METHODS}}</span>
            </div>
        </div>
                </div>
                <div class="listContainer resource"
                    *ngIf="apiService.selectedTab === 'SETTINGS' && apiService.activeServiceType === 'OpenAPIService'">
                    <wms-api-settings></wms-api-settings>
                </div>
        </div>
        </div>
        <!-- no service found -->
        <p class="alert alert-info no-service-found" *ngIf="apiService.noServicesFound" role="alert">
            <i class="glyphicon glyphicon-info-sign"></i>
            {{locale.LABEL_NO_SERVICE_FOUND}}
        </p>
    </div>
</div>

<wms-unsaved-changes-dialog id="api" [message]="getAPISaveDialogDescription()" [saveBtnLabel]="locale.LABEL_YES" [cancelBtnLabel]="locale.LABEL_NO"
(saveEvent)="saveChanges(true)" (cancelEvent)="resetChanges(true)" (closeEvent)="closeModal()"></wms-unsaved-changes-dialog>

<wms-dialog id="Re-importAPIModal" [content]="ImportApiContent"
            customClasses="{{this.apiService?.smdialogData == 3 ? 'modal web-services-container-dialog small wm-studio-dialog fade reimport-dialog' : 'modal web-services-container-dialog large wm-studio-dialog fade'}}">
</wms-dialog>
<ng-template #ImportApiContent>
  <wms-import-api [modalName]="modalName" class="restapi-dialog"
                  (refreshService)="getOpenApiServices($event?.reload ? $event.reload : true, $event?.swagger)"
                  (onModalClose)="closeDialogWithId('Re-importAPIModal')"></wms-import-api>
</ng-template>
